import { BackgroundTradingSolution, VectorKeyService } from '@/assets';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionThreeFlipCard = () => {
  const { t } = useTranslation();
  return (
    <section className="section-three-flip-card">
      <div className="layout-grid">
        <div className="grid-row">
          <div className="card-box">
            <p className="number">[01]</p>
            <div className="information">
              <p className="title">{t('AI Algorithms')}</p>
              <p className="desc">
                {t(
                  'Leverage our AI-driven algorithms to enhance trading strategies. We develop intelligent models for predictive analytics, market trend analysis, and automated decision-making, enabling faster, smarter, and more profitable trades.'
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="grid-row">
          <div className="card-box">
            <p className="number">[02]</p>
            <div className="information">
              <p className="title">{t('Monitor System')}</p>
              <p className="desc">
                {t(
                  'Stay ahead with our real-time monitoring systems. We build tools to track market data, portfolio performance, and system health, ensuring you have actionable insights and full control over your trading operations.'
                )}
              </p>
            </div>
            <div className="grid-box top-left">
              <div className="line-column" />
              <div className="line-row" />
            </div>
          </div>
        </div>
        <div className="grid-row">
          <div className="card-box">
            <p className="number">[03]</p>
            <div className="information">
              <p className="title">{t('Backtesting Methodology')}</p>
              <p className="desc">
                {t(
                  'Validate your trading strategies with our sophisticated backtesting frameworks. We design methodologies to simulate and analyze historical data, helping you refine strategies and minimize risks before live deployment.'
                )}
              </p>
            </div>
            <div className="grid-box top-left">
              <div className="line-column" />
              <div className="line-row" />
            </div>
          </div>
        </div>
      </div>
      <div className="vector-trading">
        <VectorKeyService />
      </div>
      <div className="background-trading">
        <img src={BackgroundTradingSolution} alt="bg-trading" />
      </div>
    </section>
  );
};

export default React.memo(SectionThreeFlipCard);
